import Link from "next/link";
import clsx from "clsx";
import { useMemo, useState } from "react";
import { useSwipeable } from "react-swipeable";
import Icon from "/components/common/icon";
import { useDispatch } from "react-redux";
import Tooltip from "../../../../common/tooltip";
import { showPopup } from "/redux/action-creaters/popup";
import { popupTypes } from "/redux/reducers/popupReducer";
import styles from "./index.module.scss";

export default function Picture({
  path,
  alt,
  images = "",
  stick,
  video,
  name,
  link,
}) {
  const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const currentPicture = useMemo(() => {
    return images?.length > 0 ? images[activeIndex] : "/no_photo.jpeg";
  }, [activeIndex]);

  const picturesFiltered = useMemo(() => {
    return images?.slice(0, 4);
  }, [images]);

  const moveNext = () => {
    if (activeIndex === picturesFiltered.length - 1) {
      setActiveIndex(0);
    } else {
      setActiveIndex(activeIndex + 1);
    }
    setIsLoading(true);
    const body = document.querySelector("body");
    body.classList.remove("unscroll");
  };

  const moveBack = () => {
    if (activeIndex === 0) {
      setActiveIndex(picturesFiltered.length - 1);
    } else {
      setActiveIndex(activeIndex - 1);
    }
    setIsLoading(true);
    const body = document.querySelector("body");
    body.classList.remove("unscroll");
  };

  const [onSwipedAction, setOnSwipedAction] = useState("");

  const swipeEnd = () => {
    setOnSwipedAction("");
    const body = document.querySelector("body");
    body.classList.remove("unscroll");
  };

  const handlers = useSwipeable({
    onSwipedLeft: moveNext,
    onSwipedRight: moveBack,
    onSwiping: (action) => {
      const body = document.querySelector("body");
      if (action.deltaX > 10) {
        setOnSwipedAction("back");
        body.classList.add("unscroll");
      }
      if (action.deltaX < -10) {
        setOnSwipedAction("next");
        body.classList.add("unscroll");
      }
    },
    onSwiped: swipeEnd,
    // preventScrollOnSwipe: true,
    trackMouse: true,
  });

  return (
    <Link href={path}>
      <a
        className={styles.Photo}
        onMouseLeave={() => {
          setActiveIndex(0);
        }}
      >
        {stick?.NAME && (
          <p className={clsx(styles.Stick, styles[`Stick--${stick.CODE}`])}>
            {stick.NAME}
          </p>
        )}
        {video && (
          <Tooltip text={"Посмотреть видео о товаре"}>
            <div
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  showPopup(popupTypes.productVideo, {
                    name,
                    link,
                    video,
                  }),
                );
              }}
              className={styles.Video}
            >
              <span></span>
            </div>
          </Tooltip>
        )}
        <span
          className={clsx(
            styles.ImgWrapper,
            isLoading && styles.ImgWrapperLoading,
          )}
        >
          {isLoading && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 50 50"
            >
              <path d="M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="0.5s"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          )}
          <img
            itemProp="image"
            onLoad={() => {
              setIsLoading(false);
            }}
            // На телефоне карточка — почти экран, а грузились сразу все 24 фото
            // (~340 КБ) и на медленной связи забивали канал запросам корзины
            loading="lazy"
            src={currentPicture}
            alt={alt}
            title={alt}
          />
        </span>
        {images?.length > 1 && (
          <div className={styles.Selectors} {...handlers}>
            {picturesFiltered.map((picture, index) => (
              <span
                key={index}
                className={clsx(
                  activeIndex === index && styles.ActiveSelector,
                  styles.Selector,
                )}
                onMouseEnter={() => {
                  if (index !== activeIndex) {
                    setActiveIndex(index);
                    setIsLoading(true);
                  }
                }}
              ></span>
            ))}
          </div>
        )}
        {images?.length > 1 && (
          <div className={styles.Arrows}>
            <span
              onClick={moveBack}
              className={clsx(
                styles.Arrow,
                onSwipedAction === "back" && styles.ArrowSwiped,
              )}
            >
              <Icon id="arrow" width={20} height={30} />
            </span>

            <span
              onClick={moveNext}
              className={clsx(
                styles.Arrow,
                onSwipedAction === "next" && styles.ArrowSwiped,
              )}
            >
              <Icon id="arrow" width={20} height={30} />
            </span>
          </div>
        )}
        {activeIndex === 3 && <span>Смотреть все фото</span>}
      </a>
    </Link>
  );
}
